import { MdAccessTime, MdSchedule } from "react-icons/md"

import {
	exibirPrazoFilaHoje,
	normalizarPrazoFila,
	textoLimiteEntradaFila,
	textoMinutosRestantes,
} from "./gestaoVagaFilaUi.js"

/**
 * Prazo de entrada na fila hoje (texto curto).
 */
export default function GestaoVagaFilaPrazoStatus({ vaga, compacto = false }) {
	if (!exibirPrazoFilaHoje(vaga)) return null

	const prazo = normalizarPrazoFila(vaga)
	const encerrado = Boolean(prazo.prazoEncerrado) && !prazo.jaEntrouHoje
	const jornadaFim = Boolean(prazo.jornadaEncerrada)
	const reentrada = Boolean(prazo.reentrada)
	const atrasado = Boolean(prazo.estaAtrasado) && !encerrado && !reentrada
	const limite = textoLimiteEntradaFila(prazo)
	const restante = textoMinutosRestantes(prazo)

	if (atrasado) {
		return (
			<div
				className={`gv-fila-prazo gv-fila-prazo--atrasado${
					compacto ? " gv-fila-prazo--compact" : ""
				}`}
				role="alert"
			>
				<div className="gv-fila-prazo__atrasado-head">
					<MdSchedule size={22} aria-hidden />
					<div>
						<strong className="gv-fila-prazo__atrasado-titulo">Você está atrasado</strong>
						{limite ? (
							<p className="gv-fila-prazo__atrasado-texto m-0">{limite}</p>
						) : null}
					</div>
				</div>
				{restante ? (
					<p className="gv-fila-prazo__limite m-0">
						<MdAccessTime size={16} aria-hidden />
						<span>{restante}</span>
					</p>
				) : null}
			</div>
		)
	}

	if (encerrado) {
		return (
			<div
				className={`gv-fila-prazo gv-fila-prazo--encerrado${
					compacto ? " gv-fila-prazo--compact" : ""
				}`}
			>
				<p className="gv-fila-prazo__encerrado m-0">Prazo da primeira entrada encerrado</p>
			</div>
		)
	}

	if (jornadaFim) {
		return (
			<div
				className={`gv-fila-prazo gv-fila-prazo--encerrado${
					compacto ? " gv-fila-prazo--compact" : ""
				}`}
			>
				<p className="gv-fila-prazo__encerrado m-0">Jornada encerrada hoje</p>
			</div>
		)
	}

	if (!limite) return null

	return (
		<div
			className={`gv-fila-prazo gv-fila-prazo--info${
				reentrada ? " gv-fila-prazo--reentrada" : ""
			}${compacto ? " gv-fila-prazo--compact" : ""}`}
		>
			<p className="gv-fila-prazo__limite m-0">
				<MdAccessTime size={16} aria-hidden />
				<span>{limite}</span>
				{restante ? <span className="gv-fila-prazo__restante">{restante}</span> : null}
			</p>
		</div>
	)
}
